export const Webview = (props) => <iframe {...props} />;
